export const cityFull: Record<string, string> = {
  '1201': 'GRESIK',
  '1202': 'SIDOARJO',
  '1204': 'JOMBANG',
  '1205': 'SAMPANG',
  '1206': 'PAMEKASAN',
  '1207': 'SUMENEP',
  '1208': 'BANGKALAN',
  '1209': 'BONDOWOSO',
  '1211': 'BANYUWANGI',
  '1212': 'JEMBER',
  '1215': 'PROBOLINGGO',
  '1216': 'LUMAJANG',
  '1218': 'NGANJUK',
  '1219': 'TULUNGAGUNG',
  '1220': 'TRENGGALEK',
  '1221': 'BLITAR',
  '1222': 'MADIUN',
  '1223': 'NGAWI',
  '1224': 'MAGETAN',
  '1225': 'PONOROGO',
  '1226': 'PACITAN',
  '1227': 'BOJONEGORO',
  '1228': 'TUBAN',
  '1229': 'LAMONGAN',
  '1230': 'SITUBONDO',
  '1271': 'BATU',
  '1291': 'SURABAYA',
  '1292': 'MOJOKERTO',
  '1293': 'MALANG',
  '1294': 'PASURUAN',
  '1297': 'KEDIRI',
  '2301': 'BENGKULU SELATAN',
  '2302': 'BENGKULU UTARA',
  '2303': 'REJANG LEBONG',
  '2304': 'LEBONG',
  '2305': 'KEPAHIANG',
  '2306': 'MUKOMUKO',
  '2307': 'SELUMA',
  '2308': 'KAUR',
  '2309': 'BENGKULU TENGAH',
  '2391': 'BENGKULU',
  '3101': 'BATANGHARI',
  '3104': 'SAROLANGUN',
  '3105': 'KERINCI',
  '3106': 'MUARO JAMBI',
  '3107': 'TANJUNG JABUNG BARAT',
  '3108': 'TANJUNG JABUNG TIMUR',
  '3109': 'TEBO',
  '3111': 'MERANGIN',
  '3112': 'BUNGO',
  '3191': 'JAMBI',
  '3192': 'SUNGAI PENUH',
  '3201': 'ACEH BESAR',
  '3202': 'PIDIE',
  '3203': 'ACEH UTARA',
  '3204': 'ACEH TIMUR',
  '3205': 'ACEH SELATAN',
  '3206': 'ACEH BARAT',
  '3207': 'ACEH TENGAH',
  '3208': 'ACEH TENGGARA',
  '3209': 'ACEH SINGKIL',
  '3210': 'ACEH JEUMPA/BIREUEN',
  '3211': 'ACEH TAMIANG',
  '3212': 'GAYO LUWES',
  '3213': 'ACEH BARAT DAYA',
  '3214': 'ACEH JAYA',
  '3215': 'NAGAN RAYA',
  '3216': 'SIMEULEU',
  '3217': 'BENER MERIAH',
  '3218': 'PIDE JAYA',
  '3219': 'SUBULUSSALAM',
  '3291': 'BANDA ACEH',
  '3292': 'SABANG',
  '3293': 'LHOKSEUMAWE',
  '3294': 'LANGSA',
  '3301': 'DELI SERDANG',
  '3302': 'LANGKAT',
  '3303': 'KARO',
  '3304': 'SIMALUNGUN',
  '3305': 'LABUHAN BATU',
  '3306': 'ASAHAN',
  '3307': 'DAIRI',
  '3308': 'TAPANULI UTARA',
  '3309': 'TAPANULI TENGAH',
  '3310': 'TAPANULI SELATAN',
  '3311': 'NIAS',
  '3313': 'TOBA SAMOSIR',
  '3314': 'MANDAILING NATAL',
  '3315': 'NIAS SELATAN',
  '3316': 'HUMBANG HASUNDUTAN',
  '3317': 'PAKPAK BARAT',
  '3318': 'SAMOSIR',
  '3319': 'SERDANG BEDAGAI',
  '3320': 'ANGKOLA SIPIROK',
  '3321': 'BATU BARA',
  '3322': 'PADANG LAWAS',
  '3323': 'PADANG LAWAS UTARA',
  '3324': 'LABUANBATU SELATAN',
  '3325': 'LABUANBATU UTARA',
  '3326': 'NIAS BARAT',
  '3327': 'NIAS UTARA',
  '3391': 'TEBING TINGGI',
  '3392': 'BINJAI',
  '3393': 'PEMATANG SIANTAR',
  '3394': 'TANJUNG BALAI',
  '3395': 'SIBOLGA',
  '3396': 'MEDAN',
  '0292': 'MEDAN',
  '3397': 'GUNUNG SITOLI',
  '3399': 'PADANG SIDEMPUAN',
  '3401': 'AGAM',
  '3402': 'PASAMAN',
  '3403': 'LIMAPULUH KOTO',
  '3404': 'SOLOK SELATAN',
  '3405': 'PADANG PARIAMAN',
  '3406': 'PESISIR SELATAN',
  '3407': 'TANAH DATAR',
  '3408': 'SIJUNJUNG',
  '3409': 'KEPULAUAN MENTAWAI',
  '3410': 'PASAMAN BARAT',
  '3411': 'DHARMASRAYA',
  '3491': 'BUKITTINGGI',
  '3492': 'PADANG',
  '3493': 'SAWAHLUNTO',
  '3494': 'PADANG PANJANG',
  '3495': 'SOLOK',
  '3496': 'PAYAKUMBUH',
  '3497': 'PARIAMAN',
  '3501': 'KAMPAR',
  '3502': 'BENGKALIS',
  '3504': 'INDRAGIRI HULU',
  '3505': 'INDRAGIRI HILIR',
  '3508': 'ROKAN HULU',
  '3509': 'ROKAN HILIR',
  '3510': 'PELALAWAN',
  '3511': 'SIAK',
  '3512': 'KUANTAN SINGINGI',
  '3513': 'KEPULAUAN MERANTI',
  '3591': 'PEKANBARU',
  '3592': 'DUMAI',
  '3606': 'MUSI BANYUASIN',
  '3607': 'OGAN KOMERING ULU',
  '3608': 'LEMATANG ILIR OGAN TENGAH (MUARA ENIM)',
  '3609': 'LAHAT',
  '3610': 'MUSI RAWAS',
  '3611': 'OGAN KOMERING ILIR',
  '3613': 'BANYUASIN',
  '3614': 'OGAN KOMERING ULU SELATAN',
  '3615': 'OGAN KOMERING ULU TIMUR',
  '3616': 'OGAN ILIR',
  '3617': 'EMPAT LAWANG',
  '3618': 'KAB. MUSI RAWAS UTARA',
  '3619': 'KAB. PENUKAL ABAB LEMATANG ILIR',
  '3691': 'PALEMBANG',
  '3693': 'LUBUKLINGGAU',
  '3694': 'PRABUMULIH',
  '3697': 'PAGAR ALAM',
  '3701': 'BANGKA',
  '3702': 'BELITUNG',
  '3703': 'BANGKA BARAT',
  '3704': 'BANGKA SELATAN',
  '3705': 'BANGKA TENGAH',
  '3706': 'BELITUNG TIMUR',
  '3707': 'BANGKA BELITUNG',
  '3791': 'PANGKAL PINANG',
  '3801': 'KARIMUN',
  '3802': 'LINGGA',
  '3803': 'NATUNA',
  '3804': 'BINTAN (D/H KEPULAUAN RIAU)',
  '3805': 'ANAMBAS',
  '3891': 'TANJUNGPINANG',
  '3892': 'BATAM',
  '3901': 'LAMPUNG SELATAN',
  '3902': 'LAMPUNG TENGAH',
  '3903': 'LAMPUNG UTARA',
  '3904': 'LAMPUNG BARAT',
  '3905': 'TULANG BAWANG',
  '3906': 'TANGGAMUS',
  '3907': 'LAMPUNG TIMUR',
  '3908': 'WAY KANAN',
  '3909': 'PESAWARAN',
  '3910': 'PRINGSEWU',
  '3911': 'TULANG BAWANG BARAT',
  '3912': 'MESUJI',
  '3913': 'KAB. PESISIR BARAT',
  '3991': 'BANDAR LAMPUNG',
  '3992': 'METRO',
  '5102': 'TANAH LAUT',
  '5103': 'TAPIN',
  '5104': 'HULU SUNGAI SELATAN',
  '5105': 'HULU SUNGAI TENGAH',
  '5106': 'HULU SUNGAI UTARA',
  '5107': 'BARITO KUALA',
  '5108': 'BARU',
  '5109': 'TABALONG',
  '5110': 'TANAH BUMBU',
  '5111': 'BALANGAN',
  '5191': 'BANJARMASIN',
  '5192': 'BANJARBARU',
  '5301': 'PONTIANAK',
  '5302': 'SAMBAS',
  '5303': 'KETAPANG',
  '5304': 'SANGGAU',
  '5305': 'SINTANG',
  '5306': 'KAPUAS HULU',
  '5307': 'BENGKAYANG',
  '5308': 'LANDAK',
  '5309': 'SEKADAU',
  '5310': 'MELAWI',
  '5311': 'KAYONG UTARA',
  '5312': 'KUBU RAYA',
  '5392': 'SINGKAWANG',
  '5401': 'KUTAI KARTANEGARA',
  '5402': 'BERAU',
  '5403': 'PASIR',
  '5404': 'BULUNGAN',
  '5405': 'KUTAI BARAT',
  '5406': 'KUTAI TIMUR',
  '5409': 'NUNUKAN',
  '5410': 'MALINAU',
  '5411': 'PENAJAM PASER UTARA',
  '5412': 'TANA TIDUNG',
  '5413': 'KAB. MAHAKAM ULU',
  '5491': 'SAMARINDA',
  '5492': 'BALIKPAPAN',
  '5493': 'TARAKAN',
  '5494': 'BONTANG',
  '5801': 'KAPUAS',
  '5802': 'WARINGIN BARAT',
  '5803': 'WARINGIN TIMUR',
  '5804': 'MURUNG RAYA',
  '5805': 'BARITO TIMUR',
  '5806': 'BARITO SELATAN',
  '5807': 'GUNUNG MAS',
  '5808': 'BARITO UTARA',
  '5809': 'PULANG PISAU',
  '5810': 'SERUYAN',
  '5811': 'KATINGAN',
  '5812': 'SUKAMARA',
  '5813': 'LAMANDAU',
  '5892': 'PALANGKARAYA',
  '6001': 'DONGGALA',
  '6002': 'POSO',
  '6003': 'PARIMO/BANGGAI',
  '6004': 'TOLI-TOLI',
  '6005': 'BANGGAI KEPULAUAN',
  '6006': 'MOROWALI',
  '6007': 'BUOL',
  '6008': 'TOJO UNA-UNA',
  '6009': 'PARIGI MOUTONG',
  '6010': 'SIGI',
  '6011': 'KAB. BANGGAI LAUT',
  '6012': 'KAB. MOROWALI UTARA',
  '6091': 'PALU',
  '6101': 'PINRANG',
  '6102': 'GOWA',
  '6103': 'WAJO',
  '6105': 'BONE',
  '6106': 'TANA TORAJA',
  '6107': 'MAROS',
  '6109': 'LUWU',
  '6110': 'SINJAI',
  '6111': 'BULUKUMBA',
  '6112': 'BANTAENG',
  '6113': 'JENEPONTO',
  '6114': 'SELAYAR',
  '6115': 'TAKALAR',
  '6116': 'BARRU',
  '6117': 'SIDENRENG RAPPANG',
  '6118': 'PANGKAJENE KEPULAUAN',
  '6119': 'SOPPENG (D/H WATANSOPPENG)',
  '6121': 'ENREKANG',
  '6122': 'LUWU TIMUR (D/H LUWU SELATAN)',
  '6124': 'LUWU UTARA',
  '6125': 'TORAJA UTARA',
  '6191': 'MAKASSAR',
  '6192': 'PARE-PARE',
  '6193': 'PALOPO',
  '6202': 'MINAHASA',
  '6203': 'BOLAANG MONGONDOW',
  '6204': 'SANGIHE',
  '6205': 'KEPULAUAN TALAUD',
  '6206': 'MINAHASA SELATAN',
  '6207': 'MINAHASA UTARA',
  '6209': 'MINAHASA TENGGARA',
  '6210': 'BOLAANG MONGOUNDOW UTARA',
  '6211': 'KEPULAUAN SITARO',
  '6212': 'BOLAANG MONGONDOW SELATAN',
  '6213': 'BOLAANG MONGONDOW TIMUR',
  '6288': 'SULAWESI UTARA',
  '6291': 'MENADO',
  '6292': 'MOBAGU',
  '6293': 'BITUNG',
  '6294': 'TOMOHON',
  '6301': 'GORONTALO',
  '6302': 'BUALEMO',
  '6303': 'BONEBOLANGO',
  '6304': 'POHUWATO',
  '6305': 'GORONTALO UTARA',
  '6401': 'POLEWALI MANDAR',
  '6402': 'MAJENE',
  '6403': 'MAMASA',
  '6404': 'MAMUJU UTARA',
  '6405': 'KAB. MAMUJU TENGAH',
  '6406': 'KAB. MAMUJU',
  '6491': 'MAMUJU',
  '6901': 'BUTON',
  '6903': 'MUNA',
  '6904': 'KOLAKA',
  '6905': 'WAKATOBI',
  '6906': 'KONAWE',
  '6907': 'KONAWE SELATAN',
  '6908': 'BOMBANA',
  '6909': 'KOLAKA UTARA',
  '6910': 'BUTON UTARA',
  '6911': 'KONAWE UTARA',
  '6912': 'KAB. KALOKA TIMUR',
  '6913': 'KAB. KONAWE KEPULAUAN',
  '6914': 'KAB. BUTON SELATAN',
  '6915': 'KAB. BUTON TENGAH',
  '6916': 'KAB. MUNA BARAT',
  '6990': 'BAU-BAU',
  '6991': 'KENDARI',
  '7101': 'LOMBOK BARAT',
  '7102': 'LOMBOK TENGAH',
  '7103': 'LOMBOK TIMUR',
  '7104': 'SUMBAWA',
  '7106': 'DOMPU',
  '7107': 'SUMBAWA BARAT',
  '7108': 'LOMBOK UTARA',
  '7191': 'MATARAM',
  '7192': 'BIMA',
  '7201': 'BULELENG',
  '7202': 'JEMBRANA',
  '7203': 'TABANAN',
  '7204': 'BADUNG',
  '7205': 'GIANYAR',
  '7206': 'KLUNGKUNG',
  '7207': 'BANGLI',
  '7208': 'KARANGASEM',
  '7291': 'DENPASAR',
  '7402': 'TIMOR-TENGAH SELATAN',
  '7403': 'TIMOR-TENGAH UTARA',
  '7404': 'BELU',
  '7405': 'ALOR',
  '7406': 'FLORES TIMUR',
  '7407': 'SIKKA',
  '7408': 'ENDE',
  '7409': 'NGADA',
  '7410': 'MANGGARAI',
  '7411': 'SUMBA TIMUR',
  '7412': 'SUMBA BARAT',
  '7413': 'LEMBATA',
  '7414': 'ROTE',
  '7415': 'MANGGARAI BARAT',
  '7416': 'SUMBA TENGAH',
  '7417': 'SUMBA BARAT DAYA',
  '7418': 'MANGGARAI TIMUR',
  '7419': 'NAGEKEO',
  '7420': 'SABU RAIJUA',
  '7421': 'KAB. MALAKA',
  '7491': 'KUPANG',
  '8101': 'MALUKU TENGAH',
  '8102': 'MALUKU TENGGARA',
  '8103': 'MALUKU TENGGARA BARAT',
  '8104': 'BURU',
  '8105': 'SERAM BAGIAN BARAT',
  '8106': 'SERAM BAGIAN TIMUR',
  '8107': 'KEPULAUAN ARU',
  '8108': 'MALUKU BARAT DAYA',
  '8109': 'BURU SELATAN',
  '8191': 'AMBON',
  '8192': 'TUAL',
  '8202': 'BIAK NUMFOR',
  '8210': 'YAPEN-WAROPEN',
  '8211': 'MERAUKE',
  '8212': 'PANIAI',
  '8213': 'JAYAWIJAYA',
  '8214': 'NABIRE',
  '8215': 'MIMIKA',
  '8216': 'PUNCAK JAYA',
  '8217': 'SARMI',
  '8218': 'KEEROM',
  '8221': 'PEGUNUNGAN BINTANG',
  '8222': 'YAHUKIMO',
  '8223': 'TOLIKARA',
  '8224': 'WAROPEN',
  '8226': 'BOVEN DIGOEL',
  '8227': 'MAPPI',
  '8228': 'ASMAT',
  '8231': 'SUPIORI',
  '8232': 'MAMBERAMO RAYA',
  '8233': 'DOGIYAI',
  '8234': 'LANNY JAYA',
  '8235': 'MAMBERAMO TENGAH',
  '8236': 'NDUGA TENGAH',
  '8237': 'YALIMO',
  '8238': 'PUNCAK',
  '8239': 'INTAN JAYA',
  '8240': 'DEIYAI',
  '8291': 'JAYAPURA',
  '8302': 'HALMAHERA TENGAH',
  '8303': 'HALMAHERA UTARA',
  '8304': 'HALMAHERA TIMUR',
  '8305': 'HALMAHERA BARAT',
  '8306': 'HALMAHERA SELATAN',
  '8307': 'KEPULAUAN SULA',
  '8308': 'PULAU MOROTAI',
  '8309': 'KAB. PULAU TALIABU',
  '8390': 'TERNATE',
  '8391': 'TIDORE KEPULAUAN',
  '8401': 'SORONG',
  '8402': 'FAK-FAK',
  '8403': 'MANOKWARI',
  '8404': 'SORONG SELATAN',
  '8405': 'RAJA AMPAT',
  '8406': 'KAIMANA',
  '8407': 'TELUK BINTUNI',
  '8408': 'TELUK WONDAMA',
  '8409': 'TEMBRAUW',
  '8410': 'MAYBRAT',
  '8411': 'KAB. PEGUNUNGAN ARFAK',
  '8412': 'KAB. MANOKWARI SELATAN',
  '9999': 'DI LUAR INDONESIA',
  '0191': 'BANDUNG',
  '0111': 'KAB. BANDUNG',
  '0122': 'BANDUNG BARAT',
  '0180': 'BANJAR',
  '0917': 'BANJARNEGARA',
  '0501': 'BANTUL',
  '0914': 'BANYUMAS',
  '0929': 'BATANG',
  '0198': 'BEKASI',
  '0102': 'BEKASI',
  '0913': 'BLORA',
  '0192': 'BOGOR',
  '0924': 'BOYOLALI',
  '0907': 'BREBES',
  '0115': 'CIAMIS',
  '0110': 'CIANJUR',
  '0915': 'CILACAP',
  '0291': 'CILEGON',
  '6391': 'GORONTALO',
  '0196': 'CIMAHI',
  '0116': 'CIREBON',
  '0903': 'DEMAK',
  '0197': 'DEPOK',
  '0293': 'DEPOK',
  '0500': 'DI YOGYAKARTA',
  '0300': 'DKI JAYA',
  '0114': 'GARUT',
  '0904': 'GROBOGAN',
  '0503': 'GUNUNG KIDUL',
  '0118': 'INDRAMAYU',
  '0393': 'JAKARTA BARAT',
  '0391': 'JAKARTA PUSAT',
  '0394': 'JAKARTA SELATAN',
  '0395': 'JAKARTA TIMUR',
  '0392': 'JAKARTA UTARA',
  '0911': 'JEPARA',
  '0123': 'KAB. PANGANDARAN',
  '0901': 'KAB. SEMARANG',
  '0927': 'KARANGANYAR',
  '0106': 'KARAWANG',
  '0922': 'KEBUMEN',
  '0902': 'KENDAL',
  '0396': 'KEPULAUAN SERIBU WILAYAH',
  '0923': 'KLATEN',
  '0991': 'KOTA SEMARANG',
  '0909': 'KUDUS',
  '0504': 'KULON PROGO',
  '0117': 'KUNINGAN',
  '0201': 'LEBAK',
  '0995': 'MAGELANG',
  '0119': 'MAJALENGKA',
  '0202': 'PANDEGLANG',
  '0908': 'PATI',
  '0905': 'PEKALONGAN',
  '0910': 'PEMALANG',
  '0100': 'PROPINSI JAWA BARAT',
  '0916': 'PURBALINGGA',
  '0103': 'PURWAKARTA',
  '0921': 'PURWOREJO',
  '0912': 'REMBANG',
  '0992': 'SALATIGA',
  '0203': 'SERANG',
  '0502': 'SLEMAN',
  '0925': 'SRAGEN',
  '0121': 'SUBANG',
  '0109': 'SUKABUMI',
  '0926': 'SUKOHARJO',
  '0112': 'SUMEDANG',
  '0996': 'SURAKARTA',
  '0193': 'SUUMI',
  '0204': 'TANGERANG',
  '0294': 'TANGERANG SELATAN',
  '0113': 'TASIKMALAYA',
  '0994': 'TEGAL',
  '0919': 'TEMANGGUNG',
  '0928': 'WONOGIRI',
  '0920': 'WONOSOBO',
  '0591': 'YOGYAKARTA',
}
